<div id="menu">
    <div class="entries">
    </div>
</div>